module.exports = function hellinger(a, b) {
    var ii = a.length,
        ans = 0;
    for (var i = 0; i < ii ; i++) {
        ans += Math.sqrt(a[i] * b[i]);
    }
    return 2 * Math.sqrt(1 - ans);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/hellinger.js
 ** module id = 55
 ** module chunks = 0
 **/